import { IFeed } from '@interfaces/feed';
import style from './feed-card.module.scss';
import PostTopCard from './card-container/card-top';
import PostCardMiddle from './card-container/card-middle';
import PostCardBottom from './card-container/card-bottom';

type Props = {
  feed: IFeed;
  priority?: boolean;
};

export default function FeedCard({
  feed, priority = false
}: Props) {
  return (
    <div className={style['feed-card']} id={`feed-${feed._id}`}>
      <PostTopCard feed={feed} />
      <PostCardMiddle feed={feed} priority={priority} />
      <PostCardBottom feed={feed} />
    </div>
  );
}

FeedCard.defaultProps = {
  priority: false
};
